import React, { useEffect, useState } from "react";
import echarts from "echarts";
import PropTypes from "prop-types";
import { styled, ToggleButton, ToggleButtonGroup } from "@mui/material";
import Divider from "@mui/material/Divider";
import BarChart from "../../components/Charts/BarChart";
import appearance from "../../components/Charts/Appearance";
import Card from "../../components/Cards/Card";
import { useQlik } from "../../context/Qlik";
import NativeObject from "../../components/NativeObject/NativeObject";
import ComboHeader from "../../components/ComboHeader/ComboHeader";

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "space-evenly",
  width: "100%",
});

const LayoutCardWrapper = styled("div")({
  borderRadius: "16px",
  display: "flex",
  width: "100%",
  paddingRight: "10px",
  marginBottom: "20px",
});

function OnePageDesktop({ app, config }) {
  const { cards } = config.onePage;
  const { title, tooltip, customRadio, legends, comboCharts } = cards[0];
  const { setSwitchOnDemand } = useQlik();

  const [alignment, setAlignment] = useState("Sell Out");

  const initializeField = () => {
    const data = app.field("%Selecao").getData();
    const { rows } = data;
    const activeRow = rows.filter((row) => row.qState === "S");
    if (activeRow.length > 0) {
      setAlignment(activeRow[0].qText);
    }
  };

  useEffect(() => {
    if (app) {
      initializeField();
    }
  }, []);

  const handleChange = (event, newAlignment) => {
    app.field("%Selecao").selectMatch(newAlignment);
    setAlignment(newAlignment);
  };

  useEffect(() => {
    setSwitchOnDemand(false);
  }, []);

  return (
    <div className="app onePage">
      <div className="appContent">
        <LayoutCardsWrapper>
          {/* KPIS */}
          <LayoutCardWrapper style={{ height: "25%" }}>
            <Card
              style={{
                width: "100%",
                padding: "18px",
                height: "100%",
                justifyContent: "center",
                marginBotton: "10px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "40px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    width: "70%",
                    height: "40px",
                    paddingTop: "2px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  {/* TITULO */}
                  <ComboHeader
                    reference={{
                      title: {
                        hard: "Sell out Total",
                      },
                    }}
                  />
                </div>

                <div
                  style={{
                    width: "30%",
                    height: "40px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  {/* INDICADOR PORCENTAGEM */}
                  <NativeObject
                    app={app}
                    key="JtAPkSj"
                    reference={{ id: "JtAPkSj" }}
                  />
                </div>
              </div>

              <div
                style={{
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: "500px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "30%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: 'end'
                    }}
                  >
                    {/* ICONEM */}
              
                      <NativeObject
                        app={app}
                        key="pGFPZsj"
                        reference={{ id: "pGFPZsj" }}
                      />
                  </div>

                  <div
                    style={{
                      width: "70%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div className="containerKpiValueGrey">
                      {/* VALOR EM CINZA */}
                      <NativeObject
                        className="kpiValueGrey"
                        app={app}
                        key="XjGP"
                        reference={{ id: "XjGP" }}
                      />
                    </div>
                    <div className="containerKpiValueBold">
                      {/* VALOR PRINCIPAL */}
                      <NativeObject
                        className="kpiValueBold"
                        app={app}
                        key="LUTwER"
                        reference={{ id: "LUTwER" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Card>
            <Card
              style={{
                width: "100%",
                padding: "18px",
                height: "100%",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "40px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    width: "70%",
                    height: "40px",
                    paddingTop: "2px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  {/* TITULO */}
                  <ComboHeader
                    reference={{
                      title: {
                        hard: "Sell out Sortimento",
                      },
                    }}
                  />
                </div>

                <div
                  style={{
                    width: "30%",
                    height: "40px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  {/* INDICADOR PORCENTAGEM */}
                  <NativeObject
                    app={app}
                    key="femFA"
                    reference={{ id: "femFA" }}
                  />
                </div>
              </div>

              <div
                style={{
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: "500px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "30%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {/* ICONEM */}
                    <NativeObject
                      app={app}
                      key="huQZs"
                      reference={{ id: "huQZs" }}
                    />
                  </div>

                  <div
                    style={{
                      width: "70%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div className="containerKpiValueGrey">
                      {/* VALOR EM CINZA */}
                      <NativeObject
                        className="kpiValueGrey"
                        app={app}
                        key="jHHJY"
                        reference={{ id: "jHHJY" }}
                      />
                    </div>
                    <div className="containerKpiValueBold">
                      {/* VALOR PRINCIPAL */}
                      <NativeObject
                        className="kpiValueBold"
                        app={app}
                        key="XWwzzb"
                        reference={{ id: "XWwzzb" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </LayoutCardWrapper>
          {/* KPIS PREMIAÇÂO */}
          <div style={{ width: "100%", padding: "10px", paddingRight: "20px" }}>
            <Divider>
              <ComboHeader
                reference={{ title: { hard: "Premiação" } }}
              ></ComboHeader>
            </Divider>
          </div>
          <LayoutCardWrapper style={{ height: "25%" }}>
            <Card
              style={{
                width: "100%",
                padding: "18px",
                height: "100%",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "40px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    width: "70%",
                    height: "40px",
                    paddingTop: "2px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  {/* TITULO */}
                  <ComboHeader
                    reference={{
                      title: {
                        hard: "Prêmio SO Total",
                      },
                    }}
                  />
                </div>

                <div
                  style={{
                    width: "30%",
                    height: "40px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  {/* INDICADOR PORCENTAGEM */}
                  <NativeObject
                    app={app}
                    key="EXQYKmw"
                    reference={{ id: "EXQYKmw" }}
                  />
                </div>
              </div>

              <div
                style={{
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: "350px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "40%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {/* ICONEM */}
                    <NativeObject
                      app={app}
                      key="QTtpmt"
                      reference={{ id: "QTtpmt" }}
                    />
                  </div>

                  <div
                    style={{
                      width: "60%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div className="containerKpiValueGrey">
                      {/* VALOR EM CINZA */}
                      <NativeObject
                        className="kpiValueGrey"
                        app={app}
                        key="HDfQQQM"
                        reference={{ id: "HDfQQQM" }}
                      />
                    </div>
                    <div className="containerKpiValueBold">
                      {/* VALOR PRINCIPAL */}
                      <NativeObject
                        className="kpiValueBold"
                        app={app}
                        key="ypxJJYg"
                        reference={{ id: "ypxJJYg" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Card>
            <Card
              style={{
                width: "100%",
                padding: "18px",
                height: "100%",
                justifyContent: "center",
                marginBotton: "10px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "40px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    width: "70%",
                    height: "40px",
                    paddingTop: "2px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  {/* TITULO */}
                  <ComboHeader
                    reference={{
                      title: {
                        hard: "Prêmio SO Sortimento",
                      },
                    }}
                  />
                </div>

                <div
                  style={{
                    width: "30%",
                    height: "40px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  {/* INDICADOR PORCENTAGEM */}
                  <NativeObject
                    app={app}
                    key="ePpsLP"
                    reference={{ id: "ePpsLP" }}
                  />
                </div>
              </div>

              <div
                style={{
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: "350px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "40%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {/* ICONEM */}
                    <NativeObject
                      app={app}
                      key="VyYWMJ"
                      reference={{ id: "VyYWMJ" }}
                    />
                  </div>

                  <div
                    style={{
                      width: "60%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div className="containerKpiValueGrey">
                      {/* VALOR EM CINZA */}
                      <NativeObject
                        className="kpiValueGrey"
                        app={app}
                        key="tdmKsQp"
                        reference={{ id: "tdmKsQp" }}
                      />
                    </div>
                    <div className="containerKpiValueBold">
                      {/* VALOR PRINCIPAL */}
                      <NativeObject
                        className="kpiValueBold"
                        app={app}
                        key="JFgEBKp"
                        reference={{ id: "JFgEBKp" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Card>
            <Card
              style={{
                width: "100%",
                padding: "18px",
                height: "100%",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "40px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    width: "70%",
                    height: "40px",
                    paddingTop: "2px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  {/* TITULO */}
                  <ComboHeader
                    reference={{
                      title: {
                        hard: "Prêmio Total",
                      },
                    }}
                  />
                </div>

                <div
                  style={{
                    width: "30%",
                    height: "40px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  {/* INDICADOR PORCENTAGEM */}
                  <NativeObject
                    app={app}
                    key="FpJYpbk"
                    reference={{ id: "FpJYpbk" }}
                  />
                </div>
              </div>

              <div
                style={{
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: "350px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "40%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {/* ICONEM */}
                    <NativeObject
                      app={app}
                      key="QVJjh"
                      reference={{ id: "QVJjh" }}
                    />
                  </div>

                  <div
                    style={{
                      width: "60%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div className="containerKpiValueGrey">
                      {/* VALOR EM CINZA */}
                      <NativeObject
                        className="kpiValueGrey"
                        app={app}
                        key="UpjHBYB"
                        reference={{ id: "UpjHBYB" }}
                      />
                    </div>
                    <div className="containerKpiValueBold">
                      {/* VALOR PRINCIPAL */}
                      <NativeObject
                        className="kpiValueBold"
                        app={app}
                        key="ysWVGHn"
                        reference={{ id: "ysWVGHn" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </LayoutCardWrapper>
          {/* RANKINGS  */}
          <div style={{ width: "100%", padding: "10px", paddingRight: "20px" }}>
            <Divider>
              <ComboHeader
                reference={{ title: { hard: "Rankings" } }}
              ></ComboHeader>
            </Divider>
          </div>
          <LayoutCardWrapper style={{ height: "50%" }}>
            <Card
              header={{ hardTitle: "Regional" }}
              style={{ width: "100%", height: "100%" }}
            >
              <NativeObject app={app} key="pjbcm" reference={{ id: "pjbcm" }} />
            </Card>
            <Card
              header={{ hardTitle: "Distribuidores" }}
              style={{ width: "100%", height: "100%" }}
            >
              <NativeObject
                app={app}
                key="dDNmJsN"
                reference={{ id: "dDNmJsN" }}
              />
            </Card>
            <Card
              header={{ hardTitle: "Redes" }}
              style={{ width: "100%", height: "100%" }}
            >
              <NativeObject
                app={app}
                key="dTLJPm"
                reference={{ id: "dTLJPm" }}
              />
            </Card>
          </LayoutCardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

OnePageDesktop.defaultProps = {
  app: null,
  config: {},
};

OnePageDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OnePageDesktop;
